import Main from '@/views/main.vue';

let main;
const host = window.location.origin;
let baseRouter = [
  {
    path: `${host}`,
    component: main,
    alwaysShow: true,
    name: 'orderLayout',
    meta: {
      title: '订单中心',
      icon: 'iconfont icontoreview'
    },
    children: [
      {
        path: `${host}/ChiefOrderList`,
        name: 'ChiefOrderList',
        target: '_self',
        meta: {
          title: '订单处理'
        }
      },
      {
        path: `${host}/DistributorOrderList`,
        name: 'DistributorOrderList',
        target: '_self',
        meta: {
          title: '订单处理'
        }
      },
      {
        path: `${host}/ChiefContractList`,
        target: '_self',
        name: 'ChiefContractList',
        meta: {
          title: '合同处理'
        }
      },
      {
        path: `${host}/businessContractList`,
        target: '_self',
        name: 'businessContractList',
        meta: {
          // title: '合同处理(商务)'
          title: '合同处理'
        },
        children: [
          {
            path: `${host}/businessContractList/PendingBatchInfo/:contractNum`,
            component: () => import('../views/business/details/PendingBatchInfo.vue'),
            name: 'PendingBatchInfo',
            meta: {
              title: '待确认批次发货申请'
            }
          }
        ]
      },
      {
        path: `${host}/orderPersionContractList`,
        target: '_self',
        name: 'orderPersionContractList',
        meta: {
          // title: '合同处理(订)'
          title: '合同处理'
        }
      },
      {
        path: `${host}/OverseasBatchPaymentManagement`,
        target: '_self',
        name: 'OverseasBatchPaymentManagement',
        meta: {
          title: '海外批次付款管理'
        },
        children: [
          {
            path: `${host}/OverseasBatchPaymentManagement/PendingBatchPaymentDetails`,
            target: '_self',
            name: 'PendingBatchPaymentDetails',
            meta: {
              title: '待审批批次付款明细'
            }
          }
        ]
      },
      {
        path: `${host}/orderPersionDrafts`,
        target: '_self',
        name: 'orderPersionDrafts',
        meta: {
          title: '草稿箱'
        }
      },
      // 国际退换货申请-海外销售
      {
        path: `${host}/refundsAndExchangesApplication`,
        target: '_self',
        name: 'refundsAndExchangesApplication',
        meta: {
          title: '退换货申请(海外销售)'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: 'FinanceLayout',
    alwaysShow: true,
    meta: {
      title: '账务管理',
      icon: 'iconfont iconmoney'
    },
    children: [
      {
        path: `${host}/RemittanceList`,
        target: '_self',
        name: 'RemittanceList',
        meta: {
          // title: '电汇查询（代理商）'
          title: '电汇查询'
        }
      }, {
        path: `${host}/FinanceRemittanceList`,
        target: '_self',
        name: 'FinanceRemittanceList',
        meta: {
          // title: '电汇查询（财务）'
          title: '电汇查询'
        }
      }, {
        // FE-002：与电汇查询同级注册「国际退款」
        path: `${host}/OverseasRefundList`,
        target: '_self',
        name: 'OverseasRefundList',
        meta: {
          title: '国际退款'
        }
      }, {
        path: `${host}/creditTransfer`,
        target: '_self',
        name: 'creditTransfer',
        meta: {
          title: '债权移交'
        }
      }, {
        path: `${host}/settlementQuery`,
        target: '_self',
        name: 'settlementQuery',
        meta: {
          title: '直签报账管理'
        }
      }, {
        path: `${host}/invoiceNoticeManagement`,
        target: '_self',
        name: 'invoiceNoticeManagement',
        meta: {
          title: '开票通知单管理'
        }
      }, {
        path: `${host}/orderClerkWireTransferAllocation`,
        target: '_self',
        name: 'orderClerkWireTransferAllocation',
        meta: {
          title: '订单员电汇分配'
        }
      }, {
        path: `${host}/reconciliationManagement`,
        target: '_self',
        name: 'reconciliationManagement',
        meta: {
          // title: '对账单管理'
          title: '对账单管理'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: 'agent_thh',
    alwaysShow: true,
    meta: {
      title: '退换货管理',
      icon: 'iconfont iconmoney'
    },
    children: [
      {
        path: `${host}/returnExchangeChief`,
        target: '_self',
        name: 'agent_thh_list',
        meta: {
          // title: '电汇查询（代理商）'
          title: '退换货合同处理(代理商)'
        }
      },
      {
        path: `${host}/financeThhList`,
        target: '_self',
        name: 'finance_thh_list',
        meta: {
          // title: '电汇查询（代理商）'
          title: '退换货合同处理(财务)'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: 'LogisticsManagement',
    alwaysShow: true,
    meta: {
      title: '国际物流管理',
      icon: 'iconfont iconwuliu'
    },
    children: [
      {
        path: `${host}/internationalLogisticsInfo`,
        target: '_self',
        name: 'LogisticsInternational',
        meta: {
          title: '国际物流信息'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: 'orderPerson',
    alwaysShow: true,
    meta: {
      title: '权限管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: `${host}/orderPersonLimit`,
        target: '_self',
        name: 'orderPersonLimit',
        meta: {
          title: '订单员权限'
        }
      },
      {
        path: `${host}/userPermissionConfig`,
        target: '_self',
        name: 'userPermissionConfig',
        meta: {
          title: '用户菜单权限配置'
        }
      },
      {
        path: `${host}/cesUserRoleConfig`,
        target: '_self',
        name: 'cesUserRoleConfig',
        meta: {
          title: 'CES角色审批人配置'
        }
      },
      {
        path: `${host}/sysDictDataConfig`,
        target: '_self',
        name: 'sysDictDataConfig',
        meta: {
          title: '字典字段管理'
        }
      }
    ]
  },

  {
    path: `${host}`,
    component: main,
    name: 'businessPermissionManagement',
    alwaysShow: true,
    meta: {
      title: '商务权限管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'businessShipList',
        component: () => import('../views/businessManage/businessManagement/index.vue'),
        name: 'businessShipList',
        meta: {
          title: '区域部门列表',
          qx: 2
        }
      },
      {
        path: 'businessShipCopyList',
        component: () => import('../views/businessManage/ruleCopy/index.vue'),
        name: 'businessShipCopyList',
        meta: {
          title: '权限复制',
          qx: 2
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: 'agentOverdueManagement',
    alwaysShow: true,
    meta: {
      title: '客户超期管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: 'agentOverdueList',
        component: () => import('../views/agentOverdue/index.vue'),
        name: 'agentOverdueList',
        meta: {
          title: '客户超期查询',
          qx: 2
        }
      }
    ]
  },
  // {
  //   path: `${host}`,
  //   component: main,
  //   name: 'CreditManagement',
  //   alwaysShow: true,
  //   meta: {
  //     title: '信用管理',
  //     icon: 'iconfont iconquanxian'
  //   },
  //   children: [
  //     {
  //       path: `${host}/ListManagement`,
  //       target: '_self',
  //       name: 'ListManagement',
  //       meta: {
  //         title: '黄黑名单管理'
  //       }
  //     }
  //   ]
  // },
  {
    path: `${host}`,
    component: main,
    name: 'markManager',
    alwaysShow: true,
    meta: {
      title: '唛头管理',
      icon: 'iconfont iconquanxian'
    },
    children: [
      {
        path: `${host}/generalTemplateManagement`,
        target: '_self',
        name: 'generalTemplateManagement',
        meta: {
          title: '通用模板管理'
        }
      },
      {
        path: `${host}/personalizedTemplateManagement`,
        target: '_self',
        name: 'personalizedTemplateManagement',
        meta: {
          title: '个性模板管理'
        }
      },
      {
        path: `${host}/markPrinting`,
        target: '_self',
        name: 'markPrinting',
        meta: {
          title: '唛头打印'
        }
      }
    ]
  },
  {
    path: `/rebateManagement`,
    name: 'rebateManagement',
    component: main,
    meta: {
      title: '返利管理',
      icon: 'iconfont iconMyzhuanqianfanli'
    },
    children: [
      {
        path: `${host}/rebateManagement/industryRebateLimit`,
        name: 'industryRebateLimit',
        target: '_self',
        meta: {
          title: '行业返利导入'
        }
      },
      {
        path: `${host}/rebateManagement/smbRebateLimit`,
        name: 'smbRebateLimit',
        target: '_self',
        meta: {
          title: 'SMB返利导入'
        }
      },
      {
        path: `${host}/rebateManagement/SMBIssuanceOfRebates`,
        name: 'SMBIssuanceOfRebates',
        meta: {
          title: 'SMB发放返利'
        }
      },
      {
        path: `${host}/rebateManagement/financialExportRebateReport`,
        name: 'financialExportRebateReport',
        meta: {
          title: '财务导出报表'
        }
      },
      {
        path: `${host}/rebateManagement/rebateInquiryList`,
        name: 'rebateInquiryList',
        target: '_self',
        meta: {
          title: '返利查询'
        }
      },
      {
        path: `${host}/rebateManagement/rebateReceptionList`,
        name: 'rebateReceptionList',
        target: '_self',
        meta: {
          title: '返利接收'
        }
      },
      {
        path: `${host}/rebateManagement/myRebateTransferList`,
        name: 'myRebateTransferList',
        target: '_self',
        meta: {
          title: '我的返利转让'
        }
      },
      {
        path: `${host}/rebateManagement/financeQuiryList`,
        name: 'financeQuiryList',
        target: '_self',
        meta: {
          title: '返利查询'
        }
      },
      {
        path: `${host}/rebateManagement/smbInterRebateImport`,
        name: 'smbInterRebateImport',
        meta: {
          title: 'SMB国际返利导入'
        }
      },
      {
        path: `${host}/rebateManagement/interRebateSelect`,
        name: 'interRebateSelect',
        meta: {
          title: '国际返利查询(RJ)'
        }
      },
      {
        path: `${host}/rebateManagement/serviceChargeReturnList`,
        name: 'serviceChargeReturnList',
        meta: {
          title: '服务费后返'
        }
      },
      {
        path: `${host}/rebateManagement/pendingRebateList`,
        name: 'pendingRebateList',
        meta: {
          title: '待扣减返利'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: Main,
    name: `expectedDeliveryDateManager`,
    alwaysShow: true,
    meta: {
      title: '客期变更管理',
      icon: 'iconfont icon-keqi'
    },
    children: [
      {
        path: `${host}/expectedDeliveryDateApplyList`,
        name: 'expectedDeliveryDateApplyList',
        target: '_self',
        meta: {
          title: '我的申请单'
        }
      },
      {
        path: `${host}/expectedDeliveryDateApproveList`,
        name: 'expectedDeliveryDateApproveList',
        target: '_self',
        meta: {
          title: '我的审批单'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: `batteryCertificationManagement`,
    alwaysShow: true,
    meta: {
      title: '电池认证管理',
      icon: 'iconfont icon-keqi'
    },
    children: [
      {
        path: `${host}/batteryCertificationManagement`,
        name: 'batteryCertificationManagement',
        target: '_self',
        meta: {
          title: '认证台账'
        }
      }
    ]
  },
  {
    path: `${host}`,
    component: main,
    name: `creditCenter`,
    alwaysShow: true,
    meta: {
      title: '信控中心',
      icon: 'iconfont icon-keqi'
    },
    children: [
      {
        path: `${host}/creditControlApplicationList`,
        name: 'creditControlApplicationList',
        target: '_self',
        meta: {
          title: '我的申请'
        }
      },
      {
        path: `${host}/creditControlDraftList`,
        name: 'creditControlDraftList',
        target: '_self',
        meta: {
          title: '我的草稿'
        }
      },
      {
        path: `${host}/creditQuotaInquiryList`,
        name: 'creditQuotaInquiryList',
        target: '_self',
        meta: {
          title: '额度查询'
        }
      }
    ]
  }
];
export default function (optRoute, mainComponent) {
  main = mainComponent;
  baseRouter.forEach((item, index) => {
    optRoute.forEach((route) => {
      if (item.name === route.name) {
        baseRouter[index] = route;
      };
    });
  });
  return baseRouter;
}
